'use client';

import { useQuery } from '@tanstack/react-query';

import { getMainArticlesQuery } from '@/features/articles';
import { Article } from './Article';

export const Main = () => {
  const { data } = useQuery(
    getMainArticlesQuery({
      limit: 5,
      key: 'main-topics',
    })
  );

  return <Article url="/main" title="Главное" articles={data ?? []} />;
};
